import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Star } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink-500/60 bg-ink-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-1 text-gold mb-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={12} fill="currentColor" stroke="none" />
              ))}
            </div>
            <h3 className="font-display text-3xl md:text-4xl text-white leading-tight">
              Sprechen wir über <span className="italic text-gold-soft">Sauberkeit</span> auf höchstem Niveau.
            </h3>
            <p className="mt-6 text-zinc-400 max-w-md">
              {COMPANY.coverage}. Wir melden uns in der Regel innerhalb von 24 Stunden mit einem Angebot zurück.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Kontakt</p>
            <ul className="space-y-3 text-zinc-300">
              <li className="flex gap-3"><Phone size={16} className="mt-1 text-gold" />
                <a data-testid="footer-phone" href={COMPANY.phoneHref} className="hover:text-gold transition-colors">{COMPANY.phone}</a>
              </li>
              <li className="flex gap-3"><Mail size={16} className="mt-1 text-gold" />
                <a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="hover:text-gold transition-colors break-all">{COMPANY.email}</a>
              </li>
              <li className="flex gap-3"><MapPin size={16} className="mt-1 text-gold" />
                <span>
                  {COMPANY.address.street}<br />
                  {COMPANY.address.zip} {COMPANY.address.city}
                </span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Unternehmen</p>
            <ul className="space-y-3 text-zinc-300">
              <li>Geschäftsführer<br /><span className="text-white">{COMPANY.ceo}</span></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Rechtliches</p>
            <ul className="space-y-3 text-zinc-300">
              <li><Link data-testid="footer-impressum" to="/impressum" className="hover:text-gold transition-colors">Impressum</Link></li>
              <li><Link data-testid="footer-datenschutz" to="/datenschutz" className="hover:text-gold transition-colors">Datenschutzerklärung</Link></li>
            </ul>
          </div>
        </div>

        <div className="gold-divider my-12" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} {COMPANY.name}. Alle Rechte vorbehalten.</span>
          <span className="tracking-[0.3em] uppercase">{COMPANY.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
